module.exports = __webpack_public_path__ + "static/servers-7791d0de30f1b6e40eab521a880dfeed.png";